export default __webpack_public_path__ + "static/help_06_04-1-43a4644a80724e79d22bc55586d1b474.png";